const groupDeliverableFields = (fields) => {
  const introFields = fields.filter((field) => field.key === 'title');
  const deliverableGroups = [];

  for (let index = 1; index <= 20; index += 1) {
    const groupFields = fields
      .filter((field) => field.key.startsWith(`deliverable-${index}-`))
      .sort((a, b) => a.sortOrder - b.sortOrder);

    if (!groupFields.some((field) => field.key === `deliverable-${index}-title`)) {
      break;
    }

    deliverableGroups.push({ index, fields: groupFields });
  }

  return { introFields, deliverableGroups };
};

export default groupDeliverableFields;
